import { Option } from '../../../types/main';
import { User } from '../../../types/items';

export const updatedRecordList: Option[] = [
  {
    label: 'Any',
    key: '',
  },
  {
    label: '1 day',
    key: '1 day',
  },
  {
    label: '1 week',
    key: '1 week',
  },
  {
    label: '30 days',
    key: '30 days',
  },
  {
    label: '90 days',
    key: '90 days',
  },
  {
    label: '1 year',
    key: '1 year',
  },
];

export const getAssignedToList = (user: User | null): Option[] => ([
  {
    label: 'Any',
    key: '',
  },
  {
    label: 'Not assigned',
    key: '0',
  },
  {
    label: 'To me',
    key: user?.id.toString() || '',
  },
]);

export const getBillingToList: Option[] = [
  {
    label: 'Any',
    key: '',
  },
  {
    label: 'Completed',
    key: '1',
  },
  {
    label: 'Not Completed',
    key: '0',
  },
];
